// extracted by mini-css-extract-plugin
export default {"ratingScale":"RatingScaleOverlay_ratingScale__jRxt9","ratingScaleItem":"RatingScaleOverlay_ratingScaleItem__noCCF"};